import { axiosPost } from '../../axios/axios.js'

import TaskChangeTimes from '../Task/TaskChangeTimes.vue'
import TaskBackdateExecutionForm from '../Task/TaskBackdateExecutionForm.vue'

export const requestBackdateActions = {
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default: ''
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    bpDocuments: {
      type: Array,
      default: null
    }
  },
  computed: {
    displayChangeTimesButton: function () {
      if (this.report != null && !(this.taskStatus === 'BS4' || this.taskStatus === 'BS5' || this.taskStatus === 'BS6' || this.taskStatus === 'BS7' || this.taskStatus === 'BS14' || this.taskStatus === 'BS15')) {
        return this.$d_hasOperation('changeRequestTimes')
      }
      return false
    },
    displayAutoCompleteButton: function () {
      if (this.taskStatus === 'BS1' || this.taskStatus === 'BS2') {
        return this.$d_hasOperation('changeRequestTimes')
      }
      return false
    }
  },
  methods: {
    changeTimes: function () {
      let reportDocuments
      if (this.bpDocuments) {
        reportDocuments = this.bpDocuments.filter(doc => doc.type === 'requestReport')
      }
      const dialog = this.askChangeTimes({
        configMode: false,
        requestDocument: {
          id: this.request.requestId || this.request.id,
          name: this.request.name || 'Заявка',
          createTime: this.request.createTime
        },
        reportDocuments,
        handlers: {
          success: () => {
            this.$emit('task-updated')
            dialog.hide()
          }
        }
      })
    },
    getChangeTimesFormResult: function ({ requestDocument, reportDocuments }) {
      return new Promise((resolve, reject) => {
        const dialog = this.askChangeTimes({
          configMode: true,
          showSkipBtn: true,
          requestDocument,
          reportDocuments,
          handlers: {
            confirm: (config) => {
              resolve({
                dialog,
                config: config
              })
            },
            cancel: () => {
              dialog.hide()
              resolve(null)
            }
          }
        })
      })
    },
    askChangeTimes: function ({ configMode, showSkipBtn, requestDocument, reportDocuments, handlers }) {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: TaskChangeTimes,
        contentProps: {
          configMode: !!configMode,
          showSkipBtn: !!showSkipBtn,
          requestId: requestDocument.id,
          createTime: requestDocument.createTime,
          reportDocuments: JSON.parse(JSON.stringify(reportDocuments))
        },
        componentHandlers: {
          confirm: (config) => {
            if (handlers.confirm) {
              handlers.confirm(config)
            }
          },
          success: () => {
            if (handlers.success) {
              handlers.success()
            } else {
              dialog.hide()
            }
          },
          cancel: () => {
            if (handlers.cancel) {
              handlers.cancel()
            } else {
              dialog.hide()
            }
          }
        }
      })
      return dialog
    },

    // ---

    autoComplete: async function () {
      const beforeAppointment = this.taskStatus === 'BS1' || this.taskStatus === 'BS2'
      const beforeReportCheck = beforeAppointment || this.taskStatus === 'BS3' || this.taskStatus === 'BS4' || this.taskStatus === 'BS5' || this.taskStatus === 'BS6'

      const changeTimesFormResult = await this.getAutoCompletionChangeTimesFormResult()
      if (!changeTimesFormResult) {
        return
      }
      changeTimesFormResult.dialog.hide()
      const timeChangeConfig = changeTimesFormResult.config
      console.log('timeChangeConfig: ', timeChangeConfig)

      let backdateExecutionConfiguration
      if (beforeAppointment) {
        backdateExecutionConfiguration = await this.getBackdateExecutionConfiguration(timeChangeConfig)
        if (!backdateExecutionConfiguration) {
          return
        }
        console.log('backdateExecutionConfiguration: ', backdateExecutionConfiguration)
      }

      let reportProperties
      if (beforeReportCheck) {
        reportProperties = await this.getAutoCompleteReportProperties()
        if (!reportProperties) {
          return
        }
        console.log('reportProperties: ', reportProperties)
      }

      this.applyAutoComplete(backdateExecutionConfiguration, reportProperties, timeChangeConfig)
    },

    getAutoCompletionChangeTimesFormResult: function () {
      let reportDocuments
      if (this.bpDocuments) {
        reportDocuments = this.bpDocuments.filter(doc => doc.type === 'requestReport')
      }
      if (!reportDocuments || reportDocuments.length === 0) {
        reportDocuments = [{
          id: null,
          name: 'Отчёт №1',
          createTime: new Date().getTime()
        }]
      }
      return this.getChangeTimesFormResult({
        requestDocument: {
          id: this.request.requestId || this.request.id,
          name: this.request.name || 'Заявка',
          createTime: this.request.createTime
        },
        reportDocuments
      })
    },

    getAutoCompleteReportProperties: function () {
      return new Promise((resolve, reject) => {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              resolve(data)
            } else {
              resolve(null)
            }
          },
          header: 'Параметры отчёта',
          propsConfig: {
            comment: { type: 'text', label: 'Общий комментарий', autofocus: true, autogrow: true }
          },
          buttons: [
            { key: 'yes', name: 'Подтвердить' },
            { key: 'cancel', name: 'Отмена' }
          ]
        })
      })
    },

    getBackdateExecutionConfiguration: function (timeChangeConfig) {
      return new Promise((resolve, reject) => {
        const dialog = this.$d.dialog(this).show({
          maximizedOnNarrow: true,
          persistent: true,
          noWrap: true,
          contentWidth: 560,
          contentComponent: TaskBackdateExecutionForm,
          contentProps: {
            request: this.request,
            timeChangeConfig: timeChangeConfig
          },
          componentHandlers: {
            close: () => {
              dialog.hide()
              resolve(null)
            },
            confirm: (config) => {
              dialog.hide()
              resolve(config)
            }
          }
        })
      })
    },

    applyAutoComplete: function (backdateExecutionConfiguration, reportProperties, timeChangeConfig) {
      const bodyFormData = new FormData()
      // bodyFormData.set('request', this.requestId)
      bodyFormData.set('request', this.requestId)
      bodyFormData.set('executionConfig', JSON.stringify(backdateExecutionConfiguration))
      bodyFormData.set('reportProperties', JSON.stringify(reportProperties))
      if (timeChangeConfig) {
        bodyFormData.set('timeChangeConfig', JSON.stringify(timeChangeConfig))
      }

      return axiosPost({
        url: '/service/delta/requestBusinessProcess/special/autoComplete',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Изменения успешно применены',
            progress: true,
            timeout: 3000
          })

          this.$emit('task-updated')
        },
        onFailure: (response) => {
          response.message = response.message || 'Ошибка'
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message))
        }
      })
    }
  }
}
